import initMainMenu from "./redesign2025-masthead";
import initSubMainMenu from "./redesign2025-sub-masthead";

export default () => {
  initMainMenu();
  initSubMainMenu();
};
